import styled from "@emotion/styled";
import { blue, nickel } from "../color";
import YellowUser from "../assets/YellowUser";
import CrossButton from "./buttons/CrossButton";
import React from "react";
import { CustomFlex } from "./Layout.elements";

const { octalBlue } = blue;

const YellowUserProfile = styled(YellowUser)`
  width: 36px;
  height: 36px;
`;

const SelectedQuery = ({
  isFirstQuery,
  question,
  onCrossButtonChange,
  setBlackScreen,
  setQueryParams,
}) => {

  const StyledLabel = styled(CustomFlex)((props) => ({
    background: `${octalBlue}`,
    borderBottom: `1px solid var(--Neutral-Gray-4, ${nickel})`,
    borderTop: `1px solid var(--Neutral-Gray-4, ${nickel})`,
    padding: '2.5rem',
    '@media only screen and (max-width: 768px)': {
      padding: '0',
      marginTop: `${props.isFirstQuery && '5rem'}`
    },

    '& .container': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '16px',
      '@media only screen and (max-width: 768px)': {
        maxWidth: '100%',
      }
    },

    '& .text-wrapper': {
      color: '#ffffff',
      fontFamily: 'Inter-Regular, Helvetica',
      fontSize: '1rem',
      fontWeight: '400',
      width: '60rem',
      margin: '0',
      '@media only screen and (max-width: 768px)': {
        width: '100%',
      }
    }
  }))

  const handleCrossButtonChange = () => {
    onCrossButtonChange(false);
  };

  return (
    <>
      <StyledLabel
        isFirstQuery={isFirstQuery}
        content="center"
        align="center"
        style={{width: "100%" }}
      >
        <div className="wrap-question">
          <YellowUserProfile />
          <p className="text-wrapper">{question}</p>
        </div>
      </StyledLabel>
      <CrossButton
        onCrossButtonChange={handleCrossButtonChange}
        setBlackScreen={setBlackScreen}
        setQueryParams={setQueryParams}
      />
    </>
  );
};

export default SelectedQuery;
